var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root d-inline-block"},[_c('button',{staticClass:"btn btn-success iconed btn-block",on:{"click":_vm.btnClicked}},[_c('i',{staticClass:"fa fa-search"}),_c('span',[_vm._v("جستجو")])])])}
var staticRenderFns = []

export { render, staticRenderFns }